import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FavoritosState {
  menusFavoritos: string[];
}

const initialState: FavoritosState = {
  menusFavoritos: JSON.parse(localStorage.getItem("menusFavoritos") || "[]"),
};

const favoritosSlice = createSlice({
  name: "favoritos",
  initialState,
  reducers: {
    toggleFavorito: (state, action: PayloadAction<string>) => {
      const menuPath = action.payload;
      const index = state.menusFavoritos.indexOf(menuPath);

      if (index > -1) {
        state.menusFavoritos.splice(index, 1);
      } else {
        state.menusFavoritos.push(menuPath);
      }

      // Salvar no localStorage
      localStorage.setItem(
        "menusFavoritos",
        JSON.stringify(state.menusFavoritos)
      );
    },
    setFavoritos: (state, action: PayloadAction<string[]>) => {
      state.menusFavoritos = action.payload;
      localStorage.setItem(
        "menusFavoritos",
        JSON.stringify(state.menusFavoritos)
      );
    },
  },
});

export const { toggleFavorito, setFavoritos } = favoritosSlice.actions;
export default favoritosSlice.reducer;

// Selectors
export const favoritosSelectors = {
  getMenusFavoritos: (state: { favoritos: FavoritosState }) =>
    state.favoritos.menusFavoritos,
  isFavorito: (state: { favoritos: FavoritosState }, menuPath: string) =>
    state.favoritos.menusFavoritos.includes(menuPath),
};
